var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 8.9375V32.5C36 36.075 33.0545 39 29.4545 39H17.5091C15.7418 39 14.0727 38.3013 12.8455 37.0662L0 24.0987C0 24.0987 2.06182 22.1 2.12727 22.0675C2.48727 21.7587 2.92909 21.5963 3.42 21.5963C3.78 21.5963 4.10727 21.6938 4.40182 21.8562C4.46727 21.8725 11.4545 25.8538 11.4545 25.8538V6.5C11.4545 5.15125 12.5509 4.0625 13.9091 4.0625C15.2673 4.0625 16.3636 5.15125 16.3636 6.5V17.875H18V2.4375C18 1.08875 19.0964 0 20.4545 0C21.8127 0 22.9091 1.08875 22.9091 2.4375V17.875H24.5455V4.0625C24.5455 2.71375 25.6418 1.625 27 1.625C28.3582 1.625 29.4545 2.71375 29.4545 4.0625V17.875H31.0909V8.9375C31.0909 7.58875 32.1873 6.5 33.5455 6.5C34.9036 6.5 36 7.58875 36 8.9375Z",
    fill: "#4E5FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.0968fbde.svg";
export { ForwardRef as ReactComponent };